import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { ComponentsModule } from '../components/components.module';
import { CreateGameComponent } from './create-game/create-game.component';
import { HomeComponent } from './home/home.component';
import { NotFoundComponent } from './not-found/not-found.component';
import { PlayGameComponent } from './play-game/play-game.component';
import { ViewGameComponent } from './view-game/view-game.component';

const COMPONENTS = [
  CreateGameComponent,
  HomeComponent,
  NotFoundComponent,
  PlayGameComponent,
  ViewGameComponent
];

@NgModule({
  imports: [
    CommonModule,
    ComponentsModule,
    RouterModule
  ],
  declarations: COMPONENTS,
  exports: COMPONENTS
})
export class PagesModule {
}
